import AngleBracketsIcon from '@atlaskit/icon/core/angle-brackets';
import * as React from 'react';

export function SvgCode() {
  return <AngleBracketsIcon label="" testId="ads-refreshed-icon" />;
}
